import { Component } from 'preact';
import style from './Footer.scss';
import RouteHelper from '../../helpers/RouteHelper';
import { Link } from 'react-router-dom';
import Logo from '../logo';
import {FOOTSHOP_LOGO_COLORS} from '../logo/constants';

// eslint-disable-next-line react/prefer-stateless-function
export default class Footer extends Component {
	render() {
		return (
			<footer className={style.footer}>
				<Link to={RouteHelper.getUrl('/')}>
					<div className={style.logo}>
						<Logo color={FOOTSHOP_LOGO_COLORS.WHITE}/>
					</div>
				</Link>
				<div className={style.links}>
					<a href={RouteHelper.getExternalUrl('/about')}>About Footshop</a>
					<a href={RouteHelper.getExternalUrl('/faq')}>FAQ</a>
					<Link to={RouteHelper.getUrl('/shipping')}>Shipping</Link>
					{/*<a href={RouteHelper.getExternalUrl('/returns-and-exchanges')}>Returns</a>*/}
					{/*<a href={RouteHelper.getUrl('/about')}>Stores</a>*/}
				</div>
				<div className={style.media}>
					<a href={RouteHelper.getExternalUrl('/instagram')} title="Instagram"><i className="fa fa-instagram" /></a>
					<a href={RouteHelper.getExternalUrl('/youtube')} title="Youtube"><i className="fa fa-youtube-play" /></a>
					<a href={RouteHelper.getExternalUrl('/facebook')} title="Facebook"><i className="fa fa-facebook" /></a>
					<a href={RouteHelper.getExternalUrl('/twitter')} title="Twitter"><i className="fa fa-twitter" /></a>
				</div>
			</footer>
		);
	}
}



// WEBPACK FOOTER //
// ./components/footer/Footer.js